import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import messages from './message'
const locales = [
  { lable:'zh', en: "Chinese", zh: "中文" },
  { lable:'en', en: "English", zh: "英语" }
]

const storeStorage = localStorage.getItem('__presist');
const langStoreage =  storeStorage? JSON.parse(storeStorage)?.lang:null
const defaultLocale =langStoreage?langStoreage.lang:null
Vue.use(VueI18n)
const i18n = new VueI18n({
  messages,
  locale: defaultLocale||'zh'
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n


// 导出 locales，以便在应用程序中可以访问所有支持的语言列表
export { locales };